<script setup lang="ts">
  defineOptions({ name: 'AppSidebarContent' })

  defineProps({
    showBorder: {
      type: Boolean,
      default: true,
    },
  })
</script>

<template>
  <div
    :class="[
      'app-sidebar-content custom-scrollbar min-h-0 w-full flex-1 overflow-y-auto pb-2 transition-opacity duration-300 ease-in-out',
      showBorder ? 'border-r border-default border-solid border-t-0 border-b-0 border-l-0' : '',
    ]"
  >
    <slot />
  </div>
</template>

<style scoped>
  .custom-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: var(--cp-scrollbar-thumb) transparent;
  }
  .custom-scrollbar::-webkit-scrollbar {
    width: 2px;
  }
  .custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
  }
  .custom-scrollbar::-webkit-scrollbar-thumb {
    background-color: var(--cp-scrollbar-thumb);
    border-radius: 2px;
  }
  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: var(--cp-scrollbar-thumb-hover);
  }
</style>
